import { ControlledCheckbox } from '~/components/atoms/checkbox/Checkbox';
import {
    BooleanFilter_ControlsState,
    BooleanFilter_KeyWord,
    BooleanFilter_State,
} from '~/core/features/filtering/types/booleanFilter.type';
import { UpdateFilterControls } from '~/core/useSearchState';
import { CheckboxFilterLabel } from './checkboxFilterLabel/CheckboxFilterLabel';
import CheckboxFilterWrapper from './checkboxFilterWrapper/checkboxFilterWrapper';
import filterStyles from './filter.module.scss';

type BooleanFilterProps = {
    filterState: BooleanFilter_State;
    filterControls: BooleanFilter_ControlsState;
    updateFilterControls: UpdateFilterControls;
};

export const BooleanFilter = ({ filterState, filterControls, updateFilterControls }: BooleanFilterProps) => {
    const truthyValue = filterState.values.keywords.find((bool) => bool.key === 1);

    if (!truthyValue) {
        throw new Error(`Truthy value not found for Boolean filter ${filterState.name} - ${filterState.identifier}`);
    }

    const checkedWithoutResults = filterControls.values.isChecked && truthyValue.doc_count === 0;

    return (
        <CheckboxFilterWrapper>
            <ControlledCheckbox
                labelElement={
                    <BooleanLabel filterState={filterState} filterControls={filterControls} truthyValue={truthyValue} />
                }
                labelAttributes={{
                    className: checkedWithoutResults ? filterStyles.checkedWithoutResults : '',
                    'data-testid': 'filters-filter-checkbox-label',
                }}
                name={`filter-${filterState.identifier}`}
                id={`filter-${filterState.identifier}`}
                checked={filterControls.values.isChecked}
                handleChange={(e) => {
                    updateFilterControls({
                        value: {
                            check: e.target.checked,
                        },
                    });
                }}
                disabled={truthyValue.doc_count === 0 && !filterControls.values.isChecked}
                data-testid="filters-filter-checkbox-input"
            />
        </CheckboxFilterWrapper>
    );
};

const BooleanLabel = ({
    filterState,
    filterControls,
    truthyValue,
}: Pick<BooleanFilterProps, 'filterControls' | 'filterState'> & { truthyValue: BooleanFilter_KeyWord }) => {
    const description = filterState.configuration.checkboxDescription;
    const aggregationText = truthyValue.doc_count > 0 ? `${truthyValue.doc_count}` : '0';

    return (
        <CheckboxFilterLabel
            showAggregation={!filterControls.applyFilter}
            description={description ?? ''}
            aggregationText={aggregationText}
        />
    );
};
